export const DATE_YMD_PREFIX_REGEX = /^(\d{4}-\d{2}-\d{2})/;
export const DATE_YMD_STRICT_REGEX = /^\d{4}-\d{2}-\d{2}$/;
export const DOWNLOAD_CODE_REGEX = /^[A-Za-z0-9]{1,12}$/;
export const TAG_INVALID_CHARACTERS_REGEX = /[^A-Z0-9]/g;
export const TAG_INVALID_CHARACTERS_WITH_SPACES_REGEX = /[^A-Z0-9\s]/g;
export const MULTIPLE_WHITESPACE_REGEX = /\s+/g;
export const TAG_WITH_SINGLE_SPACES_REGEX = /^[A-Z0-9]+(?:\s[A-Z0-9]+)*$/;
